const CHUBB_DISABLE_DATE_TIME_PATTERN = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2}) HKT$/;
const HKT_OFFSET_HOURS = 8;

export const isChubbFunctionDisableEffective = (currentDate = new Date()) => {
    const configuredDateTime = process.env.REACT_APP_FUNCTION_DISABLE_FOR_CHUBB;
    const match = configuredDateTime?.match(CHUBB_DISABLE_DATE_TIME_PATTERN);

    if (!match || Number.isNaN(currentDate?.getTime())) {
        return false;
    }

    const [, year, month, day, hour, minute, second] = match.map(Number);
    const dateForValidation = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
    const isValidConfiguredDate = dateForValidation.getUTCFullYear() === year &&
        dateForValidation.getUTCMonth() === month - 1 &&
        dateForValidation.getUTCDate() === day &&
        dateForValidation.getUTCHours() === hour &&
        dateForValidation.getUTCMinutes() === minute &&
        dateForValidation.getUTCSeconds() === second;

    if (!isValidConfiguredDate) {
        return false;
    }

    const effectiveTimeUtc = Date.UTC(year, month - 1, day, hour - HKT_OFFSET_HOURS, minute, second);
    return currentDate.getTime() >= effectiveTimeUtc;
};